import React from 'react';
import ClientInvoiceAdminItem from '../../../Domain/ClientInvoiceAdminItem';
import ClientInvoiceService from '../../../Services/ClientInvoiceService';
import ClientInvoiceSearchParams from './ClientInvoiceSearchParams';
import ShownPanelsEnum from '../../../Enums/ShownPanelsEnum';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import CrudTypesEnum from '../../../Enums/CrudTypesEnum';
import GeneralEditWizzardBase from '../../../Elements/GeneralEditWizzard/GeneralEditWizzardBaseFigma';
import EditClientInvoiceWindowDescription from './EditClientInvoiceWindowDescription';
import contactService from '../../../Services/contactService';
import ErrorMessage from '../../../Elements/ErrorMessage';
import FinalizeClientInvoiceWindowDescription from './FinalizeClientInvoiceWindowDescription';
import dateTimeHelper from '../../../Helpers/datetimeHelper';
import ButtonTypeEnum from '../../../Enums/ButtonTypeEnum';
import ButtonColorsEnum from '../../../Enums/ButtonColorsEnum';
import IconPositionEnum from '../../../Enums/IconPositionEnum';
import MassFinalizeItem from '../../../Domain/MassFinalizeItem';
import FigmaButtonRow from '../../../Elements/FigmaButtonRow';
import BulkFinalizeClientInvoiceDescription from './BulkFinalizeClientInvoiceDesciption';
import EditCreditMemoRequestWindowDescription from '../CreditMemo/EditCreditMemoRequestWindowDescription';
import CreditMemoRequestItem from '../../../Domain/CreditMemo/CreditMemoRequestItem';
import ExportInvoicePdfsItem from '../../../Domain/ExportInvoicePdfsItem';
import ExportPdfsWindowDescription from './ExportPdfsWindowDescription';

export default class ClientInvoiceAdmin extends React.Component {
  constructor(props) {
    super(props);

    const urlParams = new URLSearchParams(window.location.search);

    this.state = {
      shownPanel: ShownPanelsEnum.None,
      // Deep-link seed for global record search (CD-5425), on the invoice's own id so the grid lands on
      // the one row the palette displayed.
      //
      // Like the ClientNameOrId seed below it, this REPLACES the search item rather than extending it, and
      // that is load-bearing rather than tidy: ClientInvoiceSearchParams defaults both a status filter and the
      // user's office. A seeded invoice in another status or another office would be filtered straight back
      // out, and the deep link would look broken while in fact working perfectly.
      searchItem: urlParams.get('CiId')
        ? { CiId: urlParams.get('CiId') }
        : urlParams.get('ClientNameOrId')
        ? { ClientNameOrId: urlParams.get('ClientNameOrId') }
        : new ClientInvoiceSearchParams(),
      allItemsInTheSearchSetAreSelected: false,
      itemList: [],
      numberOfElementsInTheTable: 0,
      selectedItem: {},
      copyItem: {},
    };

    this.startSearch = this.startSearch.bind(this);
    this.refresh = this.refresh.bind(this);
    ClientInvoiceAdminItem.editFunction = this.editInvoiceFunction.bind(this);
    ClientInvoiceAdminItem.cancelFunction = this.cancelInvoiceFunction.bind(this);
    ClientInvoiceAdminItem.finalizeFunction = this.finalizeInvoiceFunction.bind(this);
    ClientInvoiceAdminItem.copyFunction = this.copyInvoiceFunction.bind(this);
    ClientInvoiceAdminItem.createCreditMemoFunction = this.createCreditMemoFunction.bind(this);
    this.callCancelInvoiceFunction = this.callCancelInvoiceFunction.bind(this);
    this.finalizeSelectedFunction = this.finalizeSelectedFunction.bind(this);
    this.handleExportExcelButtonClick = this.handleExportExcelButtonClick.bind(this);
    this.exportInvoicePdfs = this.exportInvoicePdfs.bind(this);
    this.showPanel = this.showPanel.bind(this);
  }

  refresh(refresh) {
    if (refresh) {
      this.setState({ shownPanel: ShownPanelsEnum.None, searchItem: { ...this.state.searchItem } });
    } else this.setState({ shownPanel: ShownPanelsEnum.None });
  }

  renderOnePanel = (panelId, content) => (this.state.shownPanel === panelId ? content : null);

  showPanel(panelId) {
    panelId = panelId === this.state.shownPanel ? ShownPanelsEnum.None : panelId;
    this.setState({ shownPanel: panelId });
  }

  editInvoiceFunction(selectedId, selectedItem) {
    selectedItem.GenerationType = 'Edit';
    selectedItem.isEditing = true;
    if (selectedItem.CiVatnumber === ' ') selectedItem.CiVatnumber = '';
    if (selectedItem.CiPonumber === ' ') selectedItem.CiPonumber = '';
    if (selectedItem.CiInvoiceNumber === ' ') selectedItem.CiInvoiceNumber = '';
    if (selectedItem.CiBillToClientName === ' ') selectedItem.CiBillToClientName = '';
    if (selectedItem.CiInternalReferenceNumber === ' ') selectedItem.CiInternalReferenceNumber = '';
    if (selectedItem.CiInvoiceComment === ' ') selectedItem.CiInvoiceComment = '';
    contactService
      .GetContactListByClientId(selectedItem.CiCcid, true, true)
      .then((contacts) => {
        selectedItem.ClientContacts = contacts;
        this.setState({
          selectedItem,
          shownPanel: ShownPanelsEnum.EditItem,
        });
      })
      .catch((error) => ErrorMessage.SetErrorMessage('CA77', error));
  }

  cancelInvoiceFunction(selectedId, selectedItem) {
    ErrorMessage.SetWarningWithComment(
      `You are about to cancel this invoice (${selectedId}). Are you sure?`,
      'Comment:',
      (comment) => {
        this.callCancelInvoiceFunction(selectedId, comment);
      },
      'Yes',
      'No'
    );
  }

  callCancelInvoiceFunction(selectedId, comment) {
    ClientInvoiceService.CancelInvoice(selectedId, comment)
      .then((result) => {
        if (result.error) {
          ErrorMessage.SetErrorMessage(result.error);
        } else {
          ErrorMessage.SetNotification('Invoice set to cancelled.');
          ErrorMessage.SetLoading(false);
          this.refresh(true);
        }
      })
      .catch((error) => {
        ErrorMessage.SetErrorMessage('CIA65', error);
        ErrorMessage.SetLoading(false);
      });
    ErrorMessage.SetLoading(true);
  }

  finalizeInvoiceFunction(selectedId, selectedItem) {
    const lowerLimit = new Date(dateTimeHelper.toYYYYsMMsDD(dateTimeHelper.addDaysToDate(new Date(), 1)));
    if (selectedItem.CiOfficeId.toString() === '9' && new Date(selectedItem.FulfillmentDate) < lowerLimit)
      selectedItem.FulfillmentDate = dateTimeHelper.addDaysToDate(new Date(), 1);
    this.setState({
      selectedItem,
      shownPanel: ShownPanelsEnum.GenerateInvoice,
    });
  }

  finalizeSelectedFunction() {
    const selectedItem = new MassFinalizeItem();
    selectedItem.AllItemsInTheSearchSetAreSelected = this.state.allItemsInTheSearchSetAreSelected;
    selectedItem.NumberOfItemsSelected = this.state.allItemsInTheSearchSetAreSelected
      ? this.state.numberOfElementsInTheTable
      : this.state.itemList.filter((x) => x.Selected === true).length;
    selectedItem.SearchItem = this.state.searchItem;
    selectedItem.IdListString = this.state.itemList
      .filter((x) => x.Selected === true)
      .map((x) => x.CiId)
      .join(',');

    ClientInvoiceService.FinalizeSelectedInvoice(selectedItem)
      .then((result) => {
        if (result && result.specialError) {
          ErrorMessage.SetWarning(result.specialError);
          this.refresh(false);
          return;
        }

        if (result && result.error) {
          ErrorMessage.SetErrorMessage(result.error);
        } else if (result && result.result) {
          ErrorMessage.SetNotification('Partial success. You have got a message with the details.');
        } else {
          ErrorMessage.SetNotification('Invoice(s) finalized.');
        }
        ErrorMessage.SetLoading(false);
        this.refresh(true);
      })
      .catch((error) => {
        ErrorMessage.SetErrorMessage('AST181', error);
        ErrorMessage.SetLoading(false);
        this.refresh(false);
      });
    ErrorMessage.SetLoading(true);
  }

  copyInvoiceFunction(selectedId, selectedItem) {
    const copyItem = { ...selectedItem };
    copyItem.CiId = '';
    copyItem.GenerationType = 'New';
    copyItem.IsCopyAction = true;
    if (copyItem.CiVatnumber === ' ') copyItem.CiVatnumber = '';
    if (copyItem.CiPonumber === ' ') copyItem.CiPonumber = '';
    if (copyItem.CiInvoiceNumber === ' ') copyItem.CiInvoiceNumber = '';
    if (copyItem.CiBillToClientName === ' ') copyItem.CiBillToClientName = '';
    if (copyItem.CiInternalReferenceNumber === ' ') copyItem.CiInternalReferenceNumber = '';
    if (copyItem.CiInvoiceComment === ' ') copyItem.CiInvoiceComment = '';
    contactService
      .GetContactListByClientId(copyItem.CiCcid, true, true)
      .then((contacts) => {
        copyItem.ClientContacts = contacts;
        this.setState({
          copyItem,
          shownPanel: ShownPanelsEnum.AddNewInvoice,
        });
      })
      .catch((error) => ErrorMessage.SetErrorMessage('CA77', error));
  }

  createCreditMemoFunction(selectedId, selectedItem) {
    const item = new CreditMemoRequestItem();
    item.ClientInvoiceId = selectedItem.CiId;
    item.ClientId = selectedItem.CiCcid;
    item.FromClientInvoice = true;
    this.setState({
      selectedItem: item,
      shownPanel: ShownPanelsEnum.CreateCreditMemo,
    });
  }

  exportInvoicePdfs() {
    const selected = this.state.itemList.filter((x) => x.Selected === true).map((x) => x.CiId);
    if (
      (this.state.allItemsInTheSearchSetAreSelected && this.state.numberOfElementsInTheTable > 50) ||
      selected.length > 50
    ) {
      ErrorMessage.SetWarning(
        'Number of selected elements is over 50, which is the current upper limit to a single export.'
      );
      return;
    }

    const exportItem = new ExportInvoicePdfsItem();
    exportItem.AllItemsInTheSearchSetAreSelected = this.state.allItemsInTheSearchSetAreSelected;
    exportItem.SearchItem = this.state.searchItem;
    exportItem.IdList = selected;
    this.setState({ shownPanel: ShownPanelsEnum.Export, selectedItem: exportItem });
  }

  handleExportExcelButtonClick() {
    ClientInvoiceService.ExportAdminExcelAsync(this.state.searchItem).catch(() =>
      ErrorMessage.SetErrorMessage('CA193')
    );
    ErrorMessage.SetSuccessWithWait(
      'File creation has started and your report will be available in your personal download menu soon. You can continue to use the system while your request is being processed.'
    );
  }

  getNumberOfSelectedElements() {
    return this.state.itemList.filter((x) => x.Selected === true).length;
  }

  renderButtonsAndPanels() {
    return (
      <div>
        <FigmaButtonRow
          buttons={[
            {
              type: ButtonTypeEnum.NormalNormal,
              color: ButtonColorsEnum.Secondary,
              iconPosition: IconPositionEnum.None,
              onClick: this.exportInvoicePdfs,
              label: 'Export Invoice PDFs',
              tooltip: 'Export Client Invoice PDFs',
              disabled: this.getNumberOfSelectedElements() === 0,
            },
            {
              type: ButtonTypeEnum.NormalNormal,
              color: ButtonColorsEnum.Secondary,
              iconPosition: IconPositionEnum.None,
              onClick: () => ErrorMessage.SetApprove(this.getApproveMessage(), this.finalizeSelectedFunction),
              label: 'Finalize Selected',
              tooltip: 'Finalize Selected',
              roleKey: 'clientinvoice_finalizeselected',
              disabled: this.getNumberOfSelectedElements() === 0,
            },
            {
              type: ButtonTypeEnum.ExtraLargeNormal,
              color: ButtonColorsEnum.Secondary,
              iconPosition: IconPositionEnum.None,
              onClick: () => this.showPanel(ShownPanelsEnum.BulkFinalize),
              label: 'Invoice Bulk Finalization',
              tooltip: 'Invoice Bulk Finalization',
              roleKey: 'clientinvoice_invoicebulkfinalize',
            },
          ]}
        />
        {this.renderPanels()}
      </div>
    );
  }

  renderPanels() {
    return (
      <div>
        {this.renderOnePanel(
          ShownPanelsEnum.EditItem,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            editedItem={this.state.selectedItem}
            clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
            clickOnSave={() => this.refresh(true)}
            windowDescription={EditClientInvoiceWindowDescription}
            errorCode='CIA190'
          />
        )}
        {this.renderOnePanel(
          ShownPanelsEnum.GenerateInvoice,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            editedItem={this.state.selectedItem}
            clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
            clickOnSave={() => this.refresh(true)}
            windowDescription={FinalizeClientInvoiceWindowDescription}
            errorCode='CIA200'
          />
        )}
        {this.renderOnePanel(
          ShownPanelsEnum.AddNewInvoice,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Create}
            editedItem={this.state.copyItem}
            clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
            clickOnSave={() => this.refresh(true)}
            windowDescription={EditClientInvoiceWindowDescription}
            errorCode='CIA190'
          />
        )}
        {this.renderOnePanel(
          ShownPanelsEnum.BulkFinalize,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            editedItem={new MassFinalizeItem()}
            clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
            clickOnSave={() => this.refresh(true)}
            windowDescription={BulkFinalizeClientInvoiceDescription}
            errorCode='CIA212'
          />
        )}
        {this.renderOnePanel(
          ShownPanelsEnum.CreateCreditMemo,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Create}
            editedItem={this.state.selectedItem}
            clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
            clickOnSave={this.refresh}
            windowDescription={EditCreditMemoRequestWindowDescription}
            errorCode='CIA247'
          />
        )}
        {this.renderOnePanel(
          ShownPanelsEnum.Export,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            editedItem={this.state.selectedItem}
            clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
            clickOnSave={() => this.refresh(true)}
            windowDescription={ExportPdfsWindowDescription}
            errorCode='CIA301'
          />
        )}
      </div>
    );
  }

  getApproveMessage() {
    if (this.state.allItemsInTheSearchSetAreSelected) {
      return `Finalize all currently selected (${this.state.numberOfElementsInTheTable}) Client Invoices?`;
    }
    const idList = this.state.itemList
      .filter((x) => x.Selected === true)
      .map((x) => x.CiId)
      .join(', ');
    return `Finalize the selected Client Invoice(s)? (ids: ${idList})`;
  }

  startSearch(searchItem) {
    this.setState({ searchItem: { ...searchItem } });
  }

  render() {
    return (
      <div className='contentwrapper'>
        {this.renderButtonsAndPanels()}
        <TabOfDataTable
          type={ClientInvoiceAdminItem}
          shownPanel={this.state.shownPanel}
          serviceFunction={ClientInvoiceService.GetListBySearching}
          convertDBItemsFunction={ClientInvoiceService.ConvertDBItems}
          searchParamsType={ClientInvoiceSearchParams}
          showSearchStrip={true}
          clickOnStartSearch={this.startSearch}
          searchItem={this.state.searchItem}
          orderBy='CiId'
          orderDirection='Desc'
          isExportExcelDisabled={false}
          clickOnExportExcel={this.handleExportExcelButtonClick}
          excelExportRoleKey='clientinvoice_excelreport'
          singleSearchLine={true}
          singleSearchLinePlaceholder='Search in client id & name, po #, invoice numbers...'
          errorCode='CIA256'
          changeOfItemListFunction={(itemList, numberOfElementsInTheTable) =>
            this.setState({ itemList, numberOfElementsInTheTable })
          }
          changeOfAllItemsAreSelectedFunction={(allItemsInTheSearchSetAreSelected) => {
            this.setState({ allItemsInTheSearchSetAreSelected });
          }}
        />
      </div>
    );
  }
}
